import { render, staticRenderFns } from "./ApplySubjectList.vue?vue&type=template&id=aafe2434&"
import script from "./ApplySubjectList.vue?vue&type=script&lang=js&"
export * from "./ApplySubjectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports